// extracted by mini-css-extract-plugin
export default {"title":"FavoritePage_title__UzfHu","emptyFavoriteContainer":"FavoritePage_emptyFavoriteContainer__rjhkG"};